export const getAutocompleteOnChange = (
  newValue: any = null,
  setValue: (value: any) => void = () => null,
  multiple = false
) => {
  if (multiple) {
    return setValue(newValue.map((item: any) => item));
  }

  return setValue(newValue);
};
